import { createContext } from "react";
const emptyValue = {
    connect: undefined,
    disconnect: undefined,
};
const BleContext = createContext(emptyValue);
export default BleContext;
